import GenericTransition from './animated-vue/common/generic-transition'

export default new GenericTransition('custom-fade-in-bounce-out', 'fadeIn', 'bounceOut', false)



// WEBPACK FOOTER //
// ./src/animates/fade-in-bounce-out.js